<template>
	<div class="b_gameteams">
		<div class="w1 choose clearfix">
			<div class="nav-left">
				<ul>
					<li v-for="(value,index) in allList" :class="{'l-active':index===allIndex}" @click="alltabFun(index)">{{value}}</li>
				</ul>
			</div>
			<div class="nav-right">
				<ul>
					<li v-for="(value,index) in changList" :class="{'r-active':index === changIndex}" @click="changtabFun(index)">{{value}}</li>
				</ul>
			</div>
		</div>
		<div class="w2">
			<div class="w content ">
				<div class="title">
					<table>
						<tbody>
							<tr>
								<td class="t1"></td>
								<td class="t2">赛事</td>
								<td class="t3">时间</td>
								<td class="t4">主场球队</td>
								<td class="t5">比分</td>
								<td class="t6">客场球队</td>
								<td class="t7">半场</td>
								<td class="t8">胜负</td>
								<td class="t9">让分</td>
								<td class="t10">盘路</td>
								<td class="t11">总分</td>
								<td class="t12">大小</td>
								<td class="t13">单双</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="team">
					<div class="analytical away_view" v-if="teaminfo">
						<p>
							<span class="red-word away_name" v-if="teaminfo[0].home_team_id==team_id" v-html="teaminfo[0].home_team_zh"></span>
							<span class="red-word away_name" v-html="teaminfo[0].away_team_zh" v-else></span>
							<span>最近<span class="red-word away_num">{{teaminfo.length}}</span>场</span>
							<span>胜率：<span class="red-word away_probability">{{teaminfo[0].probability}}</span><span class="red-word2">%</span></span>
							<span>赢盘率：<span class="red-word away_win">{{winability}}</span><span class="red-word2">%</span></span>
							<span>大球：<span class="red-word away_big">{{bigability}}</span><span class="red-word2">%</span></span>
							<span>单：<span class="red-word away_dan">{{teaminfo[0].singularprobability}}</span><span class="red-word2">%</span></span>
						</p>
					</div>
					<div class="away_competition">
						<table v-for="value in teaminfo">
							<tbody>
								<tr>
									<td class="t1"></td>
									<td class="t2" :title="value.matches_name" v-html="value.league_name_zh"></td>
									<td class="t3">{{value.match_time}}</td>
									<td class="t4" v-html="value.home_name_zh"></td>
									<td class="t5">{{value.home_score}}-{{value.away_score}}</td>
									<td class="t6" v-html="value.away_name_zh"></td>
									<td class="t7" >{{value.home_score_up}}-{{value.away_score_up}}</td>
									<td class="t8" v-if="value.is_win==0" style="color:green">{{iswin[value.is_win]}}</td>
									<td class="t8" v-if="value.is_win==1" style="color:red">{{iswin[value.is_win]}}</td>
									<td class="t8" v-if="value.is_win==2" style="color:blue">{{iswin[value.is_win]}}</td>
									<td class="t9" v-if="value.odds.length>0">{{value.odds}}</td>
									<td class="t9" v-else>无</td>
									<td class="t10" v-if="value.home_team_id==team_id&&value.odds">
										<span v-if="Number(value.home_score)-Number(value.odds)>value.away_score" style="color:red">赢</span>
										<span v-if="Number(value.home_score)-Number(value.odds)<value.away_score" style="color:green">输</span>
										<span v-if="Number(value.home_score)-Number(value.odds)==value.away_score" style="color:blue">走</span>
									</td>
									<td class="t10" v-if="value.home_team_id!=team_id&&value.odds">
										<span v-if="Number(value.home_score)-Number(value.odds)>value.away_score" style="color:green">输</span>
										<span v-if="Number(value.home_score)-Number(value.odds)<value.away_score" style="color:red">赢</span>
										<span v-if="Number(value.home_score)-Number(value.odds)==value.away_score" style="color:blue">走</span>
									</td>
									<td class="t10" v-if="value.odds==''" style="color:blue">无</td>
									<td class="t11" v-html="(Number(value.home_score)+Number(value.away_score))"></td>
									<td class="t12" v-if="value.big">
										<span v-if="((Number(value.home_score)+Number(value.away_score))*1000)>value.big*100" style="color:red">大</span>
										<span v-if="((Number(value.home_score)+Number(value.away_score))*1000)==value.big*100" style="color:blue">走</span>
										<span v-if="((Number(value.home_score)+Number(value.away_score))*1000)<value.big*100" style="color:green">小</span>
									</td>
									<td class="t12" v-else style="color:blue">无</td>
									<td class="t13" v-html="issingular[value.singular]"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="nodata" v-if="!teaminfo">
					<img src="https://static.fly2a.com/nozhenrong.png" alt="" width="300px"/>
					<div class="">
						暂时没有数据内容
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from "axios";
	export default {
		data() {
			return {
				changList: ["近20场", "近15场", "近10场", "近5场"],
				changIndex: 0,
				allList: ["查看全部", "主场"],
				iswin: ["负", "胜", "平"],
				issingular: ["单", "双"],
				team_id: 0,
				allIndex: 0,
				teaminfo: null,
				winability: "--",
				bigability: "--",
				headCon: headCon()
			}
		},
		created() {
			this.team_id = this.$route.query.team_id
			this.request("basketballmatches?team_id="+this.team_id+"&num=20&arena=0",this.getTeaminfo)// 比赛信息
		},
		beforeMount() {
			var wx_login_t = this.$route.query.wx_login_t;
			if(wx_login_t){
				var href = location.href;
				if(location.href.indexOf("&") == -1){
					href = href.replace("?wx_login_t="+wx_login_t,"");
				}else{
					href = href.replace("&wx_login_t="+wx_login_t,"");
					href = href.replace("wx_login_t="+wx_login_t+"&","");
				}
				history.pushState("", "", href);
			}
		},
		mounted() {			
			$('.haed_lanqiu').addClass('nuxt-link-exact-active');
			$('footer').css("display","block");	
		},
		methods: {
			request(url, fn, type) {
				url = COMMOND.NEW_BASE_URL + url
				axios.get(url)
				.then((res) => {
					if(fn) {
						fn(res.data)
					}
				})
			},
			getTeaminfo(data) {
				this.teaminfo = data.data
				$("footer").show();
				this.$nextTick(function(){
					var t10 = $('.t10 span').text();
					var tall = 0;
					var twin = 0;
					for (var i=0; i<t10.length; i++) {
						if($($('.t10 span')[i]).text()!='无'){
							tall++
							if($($('.t10 span')[i]).text()=='赢'){
								twin++
							}
						}
					}
					if(tall){
						this.winability = Math.round(twin / tall * 100);
					}
					var t11 = $('.t11 span').text();
					tall = 0;
					twin = 0;
					for (var i=0; i<t11.length; i++) {
						if($($('.t11 span')[i]).text()!='无'){
							tall++
							if($($('.t11 span')[i]).text()=='大'){
								twin++
							}
						}
					}
					if(tall){
						this.bigability = Math.round(twin / tall * 100);
					}
				})
			},
			axiosFun(num, arena) { //球队赛事
				this.request("basketballmatches?team_id="+this.team_id+"&num="+num+"&arena="+arena,this.getTeaminfo)
			},
			xuanranFun(data) {
				var result = data.data;
				if(result != "") {
					var length = result.length
					var str = ""
					var is_win = ["负", "胜", "平"]
					for(var i = 0; i < result.length; i++) {
						if(result[i].odds.length > 0) {
							if(result[i].odds[0] != "") {
								var pan_num = result[i].odds[0][1] //让分
								//比分是正 主队减去让分 对比客队 等于盘路 例 100 - 10 = 90;
								//比分是负 主队加上让分 对比客队 等于盘路 例 100 - (-10) = 110
								var home_point = result[i].home_score;
								var away_point = result[i].away_score;
								var home_subPoint = Number(home_point) - (pan_num);
								var plcolor = "";
								var dxcolor = "";
								var sfcolor = "";

								//需要判断传过来的队伍是在主还是在客
								if(result[i].home_team_id == this.team_id) { //如果在主
									if(home_subPoint > away_point) {
										result[i].panlu = "赢"
										plcolor = "red";
									} else if(home_subPoint < away_point) {
										result[i].panlu = "输";
										plcolor = "green";
									} else {
										result[i].panlu = "走";
										plcolor = "blue";
									}
								} else { //否则在客
									if(home_subPoint > away_point) {
										result[i].panlu = "输";
										plcolor = "green"
									} else if(home_subPoint < away_point) {
										result[i].panlu = "赢";
										plcolor = "red";
									} else {
										result[i].panlu = "走";
										plcolor = "blue";
									}
								}

								var oddArr = result[i].odds; //让分
								if(result[i].odds[2] != undefined) { //大小

									var a = (result[i].home_score + result[i].away_score) * 1000;
									var b = result[i].odds[2][1] * 100;
									if(a > b) {
										result[i].daxiao = "大";
										dxcolor = "red";
									} else if(a == b) {
										result[i].daxiao = "走";
										dxcolor = "blue";
									} else {
										result[i].daxiao = "小";
										dxcolor = "green";
									}
								} else {
									result[i].daxiao = "无";
									dxcolor = "blue";
								}
							} else {
								result[i].daxiao = "无";
								oddArr = "无"
								result[i].panlu = "无"
								plcolor = "blue";
								dxcolor = "blue";
							}
						} else {
							result[i].daxiao = "无";
							oddArr = "无"
							result[i].panlu = "无"
							plcolor = "blue";
							dxcolor = "blue";
						}
						var num = Number(result[i].home_score) + Number(result[i].away_score)
						if(result[i].singular == 1) {
							result[i].danshuang = "双"
						} else if(result[i].singular == 0) {
							result[i].danshuang = "单"
						}
						if(result[i].is_win == 0) {
							sfcolor = "green"
						} else {
							sfcolor = "red"
						}
						str += '<table>';
						str += '<td class="t1"></td>';
						str += '<td  class="t2">' + result[i].league_name_zh + '</td>';
						str += '<td  class="t3">' + result[i].match_time + '</td>';
						str += '<td  class="t4">' + result[i].home_team_zh + '</td>';
						str += '<td  class="t5">' + result[i].home_score + '-' + result[i].away_score+ '</td>';
						str += '<td  class="t6">' + result[i].away_team_zh + '</td>';
						str += '<td  class="t7">' + result[i].home_score_up + '-' + result[i].away_score_up + '</td>';
						str += '<td  class="t8" style="color:' + sfcolor + '">' + is_win[result[i].is_win] + '</td>';
						str += '<td  class="t9">' + oddArr + '</td>';
						str += '<td  class="t10" style="color:' + plcolor + '">' + result[i].panlu + '</td>';
						str += '<td  class="t11">' + Number(result[i].home_score) + Number(result[i].away_score) + '</td>';
						str += '<td  class="t12" style="color:' + dxcolor + '">' + result[i].daxiao + '</td>';
						str += '<td  class="t13">' + result[i].danshuang + '</td>';
						str += '</table>';
					}
					$(".away_competition").html(str);
					if(this.team_id == result[0].away_team_id) {
						$(".away_name").html(result[0].away_team_zh)
					} else {
						$(".away_name").html(result[0].home_team_zh)
					}
					$(".away_num").html(length);
					$(".away_probability").html(result[0].probability)
					$(".away_dan").html(result[0].singularprobability)
				}
			},
			changtabFun(index) {
				this.changIndex = index;
				var arena = this.allIndex;
				if(index == 0) {
					this.axiosFun(20, arena)
				}
				if(index == 1) {
					this.axiosFun(15, arena)
				}
				if(index == 2) {
					this.axiosFun(10, arena)
				}
				if(index == 3) {
					this.axiosFun(5, arena)
				}
			},
			alltabFun(index) {
				this.allIndex = index;
				if(this.changIndex == 0) {
					var num = 20;
				}
				if(this.changIndex == 1) {
					var num = 15;
				}
				if(this.changIndex == 2) {
					var num = 10;
				}
				if(this.changIndex == 3) {
					var num = 5;
				}
				this.axiosFun(num, index)
			},
		},
		metaInfo() {
			return {
				title: this.headCon["lanqiu"]["gameteams"]["title"],
				meta: [{
						hid: "description",
						name: "description",
						content: this.headCon["lanqiu"]["gameteams"]["description"]
					},
					{
						hid: "keywords",
						name: "keywords",
						content: this.headCon["lanqiu"]["gameteams"]["keywords"]
					}
				]
			}
		}
	}
</script>

<style scoped="scoped">
	@import "../../assets/css/b-gameteams.css";
</style>
<style>
	@import "../../assets/css/gameteams.css";
</style>

